import React, { memo, useContext } from 'react'
import { FormLayoutRow, Well } from '@pushly/aqe/lib/components'
import { Input } from 'antd'
import { useDebouncer } from '@pushly/aqe/lib/hooks'
import { DEFAULT_INPUT_FIELD_DEBOUNCE_MS } from '../constants'
import { PromptEditorContext } from '../context'
import { PromptEditorDispatchContext } from '../reducer'

export const PromptGroupDetailsEditor = memo(() => {
    const [debounce] = useDebouncer(DEFAULT_INPUT_FIELD_DEBOUNCE_MS)

    const dispatch = useContext(PromptEditorDispatchContext)
    const { loading, promptGroup, isAbTestEnabled } = useContext(PromptEditorContext)

    return (
        <Well title="Details" hideFooter={true} className="generic-well">
            <FormLayoutRow
                className="prompt-group-name"
                loading={loading}
                layout="vertical"
                label="Name"
                value={
                    loading ? null : (
                        <Input
                            placeholder={isAbTestEnabled ? 'New Prompt Test Name' : 'New Prompt Name'}
                            defaultValue={promptGroup.name}
                            onChange={(ev) => {
                                const update = promptGroup.clone()
                                update.name = ev.target.value

                                debounce(() => {
                                    dispatch({ type: 'set-prompt-group', group: update })
                                })
                            }}
                        />
                    )
                }
            />
        </Well>
    )
})
